import { useNavigate } from "react-router";

import { useDialog } from "@datanac/datanac-mui-toolkit";
import { Button, IconButton } from "@mui/material";
import { BUDGET_STATUS_ACTIVE, BUDGET_STATUS_DRAFT } from "components/Budget/helpers";
import { InsuranceIcon } from "components/Icons/Icons";
import { formatPrice } from "utility/formatters";

import { TilleyCard } from "../../Cards/TilleyCard";
import { DeleteIcon } from "../../Icons/Icons";

export default function InsuranceSummaryCard({ insuranceScenario, onChange, isLoading }) {
  const navigate = useNavigate();

  const toggleStatus = () => {
    if (isLoading) return;
    const _newState = { ...insuranceScenario };
    _newState.status = insuranceScenario.status === BUDGET_STATUS_ACTIVE ? BUDGET_STATUS_DRAFT : BUDGET_STATUS_ACTIVE;
    onChange?.(_newState);
  };

  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();
  const handleDeleteOnClick = () => {
    confirmDialogActions.confirm({
      title: "Delete this entry?",
      prompt: "Are you sure you want to delete this entry?",
      promptDetail: null,
      callback: () => {
        const _newState = { ...insuranceScenario };
        _newState.is_active = false;
        onChange?.(_newState);
      },
    });
  };

  return (
    <>
      <TilleyCard
        data-testid={`open-insurance-${insuranceScenario?.name}`}
        onClick={() => navigate(`/insurance/${insuranceScenario?.id}`)}
        Avatar={InsuranceIcon}
        title={insuranceScenario?.name}
        action={
          <IconButton
            data-testid={`delete-insurance-${insuranceScenario?.name}`}
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteOnClick();
            }}
          >
            <DeleteIcon />
          </IconButton>
        }
        details={[
          {
            value: formatPrice(insuranceScenario?.totals?.producer_premium_amount_per_acre, 2),
            label: "PRODUCER PREMIUM /ac",
          },
          {
            value: formatPrice(insuranceScenario?.totals?.liability_amount_per_acre, 0),
            label: "COVERAGE /ac",
          },
        ]}
        footer={
          insuranceScenario?.status === BUDGET_STATUS_ACTIVE ? (
            <Button
              size="small"
              variant="contained"
              color={isLoading ? "inherit" : "primary"}
              onClick={(e) => {
                e.stopPropagation();
                if (isLoading) return;
                toggleStatus();
              }}
            >
              Active
            </Button>
          ) : (
            <Button
              size="small"
              variant={isLoading ? "contained" : "outlined"}
              color="inherit"
              sx={{ color: "text.secondary" }}
              onClick={(e) => {
                e.stopPropagation();
                if (isLoading) return;
                toggleStatus();
              }}
            >
              Draft
            </Button>
          )
        }
      />

      {confirmDialogComponent}
    </>
  );
}
